import React from 'react';
import { getProjectAccordingToDomain } from 'packages/utils';
import styles from './styles.module.less';
import IntlMessages from '@src/util/IntlMessages';

export default function Title({ children }) {
  const { operonda, guarnic } = getProjectAccordingToDomain();

  const TITLES = {
    operonda: 'Operonda',
    guarnic: 'Guarnic',
  };

  return (
    <div className={styles.titleContainer}>
      <div className={operonda ? styles.logo : styles.logoGuarnic}>
        {operonda ? (
          <img src="/logo_operonda.png" alt={TITLES.operonda} />
        ) : guarnic ? (
          <img src="/guarnic_144.png" alt={TITLES.guarnic} />
        ) : (
          <img src="/logo_operonda.png" alt={TITLES.operonda} />
        )}
      </div>
      <div className="gx-guarnic-headline-1">
        {children ?? (
          <IntlMessages
            id="auth.login.to"
            values={{ text: guarnic ? TITLES.guarnic : TITLES.operonda }}
          />
        )}
      </div>
    </div>
  );
}
